(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["company_list"] = factory();
	else
		root["company_list"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 